export interface RecoveryItem {
  filename: string;
  jobId: number;
  trackingNumber: string;
  status: 'confirmed' | 'resent' | 'failed';
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  organizationName: string | null;
  userId: number | null;
  organizationId: number | null;
}

/**
 * Escapes a CSV field value by wrapping it in double quotes if it contains a comma.
 */
const escapeCsvField = (value: string | number | null): string => {
  if (value === null || value === undefined) return '';
  const str = String(value);
  return str.includes(',') ? `"${str}"` : str;
};

/**
 * Builds a CSV string from a RecoveryItem array and triggers a browser file download.
 * Only items with status === 'resent' are included as data rows.
 * If no resent items exist, the file contains only the header row.
 * Filename: qdirect-recovery-<YYYY-MM-DD>.csv
 *
 * Validates: Requirements 9-DLC.1, 9-DLC.2, 9-DLC.3, 9-DLC.4, 9-DLC.5
 */
export const downloadRecoveryCsv = (items: RecoveryItem[]): void => {
  const header = 'Print File Name,First Name,Last Name,Email,Organization Name,User ID,Organization ID,Job Number';

  const resentItems = items.filter((item) => item.status === 'resent');

  const rows = resentItems.map((item) =>
    [
      escapeCsvField(item.filename),
      escapeCsvField(item.firstName),
      escapeCsvField(item.lastName),
      escapeCsvField(item.email),
      escapeCsvField(item.organizationName),
      escapeCsvField(item.userId),
      escapeCsvField(item.organizationId),
      escapeCsvField(item.trackingNumber),
    ].join(','),
  );

  const csvContent = [header, ...rows].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);

  const today = new Date().toISOString().slice(0, 10);
  const filename = `qdirect-recovery-${today}.csv`;

  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);

  URL.revokeObjectURL(url);
};
